<div class="display-flex flex-column">
  <div mat-dialog-title class="display-flex modal-header">
    <div class="subtitle">Create non-PMS Unit</div>
  </div>

  <mat-dialog-content>
    <div class="no-shadow non-pms-modal-form" [formGroup]="form">
      <app-radio-button-dropdown
        [containerCss]="'new-turnover-modal-fields w-100'"
        [items]="userProperties$ | async"
        [allowSearch]="(userProperties$ | async)?.length > 7"
        [attrDisable]="false"
        [label]="'Property'"
        formControlName="propertyId"
        [allowClear]="false"
        [attrPlaceholder]="'Select property'"
        [showValidationError]="formSubmited"
        attrAppendTo="body"></app-radio-button-dropdown>
      <app-input
        [labelCss]="'nowrap pre-label'"
        [containerCss]="'display-flex flex-column grid-gap-4'"
        [attrPlaceholder]="'unit name...'"
        formControlName="unitName"
        [attrLabel]="'Name'"
        [showValidationError]="formSubmited"></app-input>

      <app-radio-button-dropdown
        *ngIf="data?.fromBoard"
        class="flex-grow-1"
        [containerCss]="'new-turnover-modal-fields w-100'"
        [items]="workflowStepTypes"
        [allowSearch]="workflowStepTypes?.length > 7"
        [label]="'Start in'"
        formControlName="startWorkflowStepType"
        [allowClear]="false"
        [labelRequired]="true"
        [showValidationError]="formSubmited"
        attrAppendTo="body"></app-radio-button-dropdown>

      <app-radio-button-dropdown
        [containerCss]="'new-turnover-modal-fields w-100'"
        [items]="UnitIconList"
        [allowSearch]="UnitIconList?.length > 7"
        [optionWithIcon]="true"
        [attrDisable]="false"
        [label]="'Select an icon'"
        formControlName="unitIconType"
        [allowClear]="false"
        [attrPlaceholder]="'Select an icon'"
        [showValidationError]="formSubmited"
        attrAppendTo="body"></app-radio-button-dropdown>
    </div>
    <div class="remark">
      <b>Note:</b>
      <span>&nbsp;you can edit or delete this unit anytime from Unit Details</span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="display-flex grid-gap-8 justify-content-end w-100">
      <button mat-stroked-button class="modal-button" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" class="modal-button" (click)="ok()">Create</button>
    </div>
  </mat-dialog-actions>
</div>
